import { CommonModule } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { ErrorHandler, NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { CheckboxModule } from 'primeng/checkbox';
import { MessagesModule } from 'primeng/messages';
import { TabViewModule } from 'primeng/tabview';
//import { BackButtonDirective } from './component/back-button.directive';
import { DropdownConfigDirective } from './component/dropdown-config.directive';
//import { FormSubmitDirective } from './component/form-submit.directive';
//import { GlobalLoadingIndicatorComponent } from './component/global-loading-indicator/global-loading-indicator.component';
import { ControlNameDirective } from './component/input-group/control-name.directive';
import { ControlDirective } from './component/input-group/control.directive';
import { InputGroupComponent } from './component/input-group/input-group.component';
import { RequiredDirective } from './component/input-group/required.directive';
//import { MultiCheckboxComponent } from './component/multi-checkbox/multi-checkbox.component';
import { TabPanelDirective } from './component/tab-panel.directive';
//import { TableDirective } from './component/table.directive';
//import { UpdateOnMessageDirective } from './component/update-on-message.directive';
//import { UpperCaseDirective } from './component/uppercase.directive';
import { ValidCpfDirective } from './component/valid-cpf.directive';
//import { ValidHourDirective } from './component/valid-hour.directive';
import { GlobalErrorHandler } from './global-error-handler';
import { TableDirective } from '@sigepe/dsgov-theme';
import { NenhumResultadoComponent } from './component/nenhum-resultado/nenhum-resultado.component';
import { CpfPipe } from './pipes/cpf.pipe';
import { DataFormatadaPipe } from './pipes/dataFormatada.pipe';
import { CabecalhoFuncionalComponent } from './cabecalho-funcional/cabecalho-funcional.component';
import { PrimengModule } from 'src/app/modules/primeng.module';

//import { DescricaoFromIdPipe } from './pipes/descricao-from-id.pipe';
//import { SimNaoPipe } from './pipes/sim-nao.pipe';
//import { WeekDayAbrevPipe } from './pipes/week-day-abrev.pipe';

@NgModule({
    declarations: [
        CpfPipe,
        DataFormatadaPipe,
        //BackButtonDirective,
        InputGroupComponent,
        ValidCpfDirective,
        RequiredDirective,
        //DescricaoFromIdPipe,
        ControlDirective,
        ControlNameDirective,
        //TableDirective,
        //SimNaoPipe,
        TabPanelDirective,
        //FormSubmitDirective,
        //UpdateOnMessageDirective,
        //MultiCheckboxComponent,
        //ValidHourDirective,
        DropdownConfigDirective,
        //UpperCaseDirective,
        //WeekDayAbrevPipe,
        //GlobalLoadingIndicatorComponent
        NenhumResultadoComponent,
        CabecalhoFuncionalComponent
    ],
    imports: [CommonModule, ReactiveFormsModule, MessagesModule, TabViewModule, CheckboxModule, TableDirective, PrimengModule],
    exports: [
        CpfPipe,
        DataFormatadaPipe,
        //BackButtonDirective,
        InputGroupComponent,
        ValidCpfDirective,
        RequiredDirective,
        ControlDirective,
        ControlNameDirective,
        //DescricaoFromIdPipe,
        //TableDirective,
        //SimNaoPipe,
        TabPanelDirective,
        //FormSubmitDirective,
        //UpdateOnMessageDirective,
        //MultiCheckboxComponent,
        //ValidHourDirective,
        DropdownConfigDirective,
        //UpperCaseDirective,
        //WeekDayAbrevPipe,
        //GlobalLoadingIndicatorComponent
        NenhumResultadoComponent,
        CabecalhoFuncionalComponent
    ],
    providers: [{ provide: ErrorHandler, useClass: GlobalErrorHandler }, CpfPipe, DataFormatadaPipe, provideHttpClient(withInterceptorsFromDi())]
})
export class SharedModule {}
